import React from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { Home, Search, PlusCircle, Heart, User } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const items = [
  { to: "/", icon: Home, label: "Home", auth: false },
  { to: "/properties", icon: Search, label: "Search", auth: false },
  { to: "/post-property", icon: PlusCircle, label: "Post", primary: true, auth: false },
  { to: "/dashboard/favorites", icon: Heart, label: "Saved", auth: true },
  { to: "/dashboard", icon: User, label: "Profile", auth: true },
];

export default function MobileBottomNav({ onLoginClick }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const { pathname } = useLocation();

  const go = (e, it) => {
    e.preventDefault();
    if (it.auth && !user) {
      if (onLoginClick) onLoginClick();
      return;
    }
    nav(it.to);
  };

  const isActivePath = (to) => {
    if (to === "/") return pathname === "/";
    return pathname === to || pathname.startsWith(to + "/");
  };

  return (
    <nav className="xl:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 shadow-2xl pb-[env(safe-area-inset-bottom)]">
      <div className="grid grid-cols-5">
        {items.map((it) => {
          const active = isActivePath(it.to);
          return (
            <NavLink
              key={it.to}
              to={it.to}
              onClick={(e) => go(e, it)}
              data-testid={`mobile-nav-${it.label.toLowerCase()}`}
              className={`flex flex-col items-center gap-0.5 py-2 text-[11px] active:scale-95 transition-transform ${it.primary ? "" : (active ? "text-kp-teal" : "text-slate-500")}`}
            >
              {it.primary ? (
                <span className="w-11 h-11 -mt-4 rounded-full btn-maroon flex items-center justify-center shadow-lg"><it.icon size={20}/></span>
              ) : (
                <it.icon size={20}/>
              )}
              <span className={it.primary ? "text-kp-maroon font-semibold" : ""}>{it.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
